/*
 * Things to watch out for:
 * Images loaded from S3 have 202404 date hardcoded
 * If we get to a point where we are updating monthly,
 * we will need to figure out how to have that updated.
 * Maybe from Version.json?
 *
 */

import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import Helmet from 'react-helmet'
import Select from 'react-select'
import {SlideDown} from 'react-slidedown'
import ReactTooltip from 'react-tooltip'
import {Row, Col} from 'react-flexbox-grid'
import Loader from 'react-loader'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  SrOnly,
  SignupForm,
  ScrollToTop,
  SelectDropdownPlan,
  CompanyProfileModal,
} from '../../components'
import Styles from './WeaponBondsIn401ks.css'
import format from '../../helpers/format'
import scroller from '../../helpers/scroller'
import container from '../../helpers/container'

import imageSocialShare from '../../../static/images/bomb-blast.jpg'

// used to control chart image loading from S3
const currYYYYMM = '202406'

// function aliases
// fm -> format.money
const fm = (m, decimals=2) => {
  return format.money(m, true, 'USD', true, 2)
  // try {
  //   return format.money(m, true, 'USD', true, 2)
  // } catch (error) {
  //   console.error('HERE HERE');
  //   console.error(m);
  //   console.error(error);
  //   // Expected output: ReferenceError: nonExistentFunction is not defined
  //   // (Note: the exact output may be browser-dependent)
  // }
}

// fp -> format.perc
const fp = (p, round=false, decimals=2) => { return format.perc(p, round, decimals) }


//
//
//
//
//
//
/**
 * <LedeNav> component
 * Display: layout, headline, text of lede at top of page,
 *          Nav with <ScrollLink> to scroll down to findings, results, etc.
 * @param title: Page/window title
 */
@CSSModules(Styles, {allowMultiple:true})
class LedeNav extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }
  //
  render() {
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    //
    return (
      <div styleName='lede-wrap'>
        <ContainerDivs>
          <div styleName='lede-flex'>
            <h1 styleName='lede-h1-wrap'>{this.props.title}</h1>
            <p styleName='lede-p-wrap'>{this.props.description}</p>
          </div>
        </ContainerDivs>
      </div>
    )
  }
}


//
// <TheIssue> component
// Display: text annd images
//
@CSSModules(Styles, {allowMultiple:true})
class TheIssue extends Component {
  render() {
    const imgMoneyFunnel = require( '../../../static/images/weapon-funnel.svg' )
    const weaponLogos = require( '../../../static/images/weapon-makers.jpg' )
    const imgBombs = require( '../../../static/images/down-bomb.svg' )
    //
    return <div>
      <div styleName='issue-wrap' id='issue'>
        <ContainerDivs>

          <div styleName='issue-nav-btn-wrap'>
            
            <Link
              to='https://www.asyousow.org/press-releases/2024/6/17/new-analysis-disney-target-and-whole-foods-investing-billions-military-weapons-manufacturers'
              title='Disney, Target, and Whole Foods Investing Billions in Military Weapons Manufacturers'
            >
              <div styleName='issue-nav-btn'>
                Press release
              </div>
            </Link>

            <ScrollLink
              activeClass='active-scroll-link'
              to='retirement-plans'
              spy
              smooth
              offset={0}
              duration={500}
            >
              <div styleName='issue-nav-btn'>
                See the data
              </div>
            </ScrollLink>

            <Link
              to='https://fossilfreefunds.org/blog/2024/06/18/is-your-401k-invested-in-bomb-makers.html'
              title='Is Your 401(k) Invested in Bomb Makers?'
            >
              <div styleName='issue-nav-btn'>
                Blog post
              </div>
            </Link>

          </div>

          <div styleName='issue-flex'>
            <div>
              <p>
                <b>Employer 401(k) plans have millions of dollars in employee savings
                invested in arms manufacturers and military contractors.</b><br/>
              </p>
              <p>
                Workers find themselves inadvertently supporting industries
                they may morally oppose: nuclear weapons, cluster munitions,
                white phosphorus.
              </p>
              <p>
                Limited fund options restrict employees from aligning their
                retirement savings with their personal values,
                while also exposing them to sustainability risk,
                potentially jeopardizing their financial future.
              </p>
              <p>
                <b>It's time for our 401(k)s to stop forcing us to invest
                in war, death, and destruction.</b>
              </p>
            </div>
            <div styleName='issue-img-wrap'>
              <img src={imgMoneyFunnel} alt='Investments'/>
              <img
                styleName='issue-logos-img'
                src={weaponLogos}
                alt='Major U.S. arms manufacturers'
              />
              <img src={imgBombs} alt='Armaments'/>
            </div>
          </div>
        </ContainerDivs>
      </div>
      <div styleName='banner-img-wrap' >
        <div styleName='banner-img' alt="Image: WHO" />
        <div styleName='banner-cite'>Image: WHO</div>
      </div>
    </div>
  }
}


//
// <PlanSelect> component
// Transforms config.plansBondsSource into a planData object
// Includes: <SelectDropdownPlan> and onPlanSelect()
//             to select an active plan,
//           <PlanResults> to display results
//             for active plan
//
@CSSModules(Styles, {allowMultiple:true})
class PlanSelect extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  //
  constructor(props) {
    super(props)
    const sorter = (arr) => {
      arr.sort((a, b) => {
        return a[0].localeCompare(b[0])
      })
      return arr
    }
    const plansData = Object.keys(config.plansBondsSource).map((key, i) => {
      const a = config.plansSource[key]
      const b = config.plansBondsSource[key]
      return {
        logo: require(
          `../../../static/images/plans/${a.path}.png`
        ),
        key:                                 key,
        // from plansSource
        plan_option_count:                    a.plan_option_count,
        plan_assets:                          a.plan_assets,
        primary_plan_name:                    a.primary_plan_name,
        short_name:                           a.short_name,
        // from plansBondsSource
        unmatched_funds_count:                b.unmatched_funds_count,
        unmatched_fund_assets:                b.unmatched_fund_assets,
        unmatched_fund_weight:                b.unmatched_fund_weight,
        matched_funds_count:                  b.matched_funds_count,
        matched_fund_assets:                  b.matched_fund_assets,
        matched_fund_weight:                  b.matched_fund_weight,
        long_equity_assets:                   b.long_equity_assets,
        long_cbond_assets:                    b.long_cbond_assets,
        //
        wff_mil_asset_bond:                   b.wff_mil_asset_bond,
        wff_mil_weight_bond:                  b.wff_mil_weight_bond,
        wff_mil_weight_bond_concentration:    b.wff_mil_weight_bond_concentration,
        wff_mil_asset_equity:                 b.wff_mil_asset_equity,
        wff_mil_weight_equity:                b.wff_mil_weight_equity,
        wff_mil_weight_equity_concentration:  b.wff_mil_weight_equity_concentration,
        wff_mil_asset_both:                   b.wff_mil_asset_equity_and_bond,
        wff_mil_weight_both:                  b.wff_mil_weight_equity_and_bond,
        //
        wff_nw_asset_bond:                    b.wff_nuclear_weapons_asset_bond,
        wff_nw_weight_bond:                   b.wff_nuclear_weapons_weight_bond,
        wff_nw_weight_bond_concentration:     b.wff_nuclear_weapons_weight_bond_concentration,
        wff_nw_asset_equity:                  b.wff_nuclear_weapons_asset_equity,
        wff_nw_weight_equity:                 b.wff_nuclear_weapons_weight_equity,
        wff_nw_weight_equity_concentration:   b.wff_nuclear_weapons_weight_equity_concentration,
        wff_nw_asset_both:                    b.wff_nuclear_weapons_asset_equity_and_bond,
        wff_nw_weight_both:                   b.wff_nuclear_weapons_weight_equity_and_bond,
        //
        wff_cm_asset_bond:                    b.wff_cluster_munitions_asset_bond,
        wff_cm_weight_bond:                   b.wff_cluster_munitions_weight_bond,
        wff_cm_weight_bond_concentration:     b.wff_cluster_munitions_weight_bond_concentration,
        wff_cm_asset_equity:                  b.wff_cluster_munitions_asset_equity,
        wff_cm_weight_equity:                 b.wff_cluster_munitions_weight_equity,
        wff_cm_weight_equity_concentration:   b.wff_cluster_munitions_weight_equity_concentration,
        wff_cm_asset_both:                    b.wff_cluster_munitions_asset_equity_and_bond,
        wff_cm_weight_both:                   b.wff_cluster_munitions_weight_equity_and_bond,
        //
        top_wff_mil_cbond_companies_in_plan:  b.top_wff_cbond_companies_in_plan,
        top_wff_mil_equity_companies_in_plan: b.top_wff_equity_companies_in_plan,
        top_wff_nw_cbond_companies_in_plan:   b.top_wff_nw_cbond_companies_in_plan,
        top_wff_nw_equity_companies_in_plan:  b.top_wff_nw_equity_companies_in_plan,
        top_wff_cm_cbond_companies_in_plan:   b.top_wff_cm_cbond_companies_in_plan,
        top_wff_cm_equity_companies_in_plan:  b.top_wff_cm_equity_companies_in_plan,
        // from planOptionsBondsSource
        plan_options_table: sorter(config.planOptionsBondsSource[key])
      }
    })
    //
    this.state = {
      plansData,
      planSelected: {
        name: 'Select a plan',
        label: 'Select a plan'
      },
      planLoading: false,
      planTimeout: null,
      retirementPlanIndex: props.retirementPlanIndex,
    }
  }
  // for initial page load on route (e.g. /adobe)
  componentWillMount() {
    if (this.state.retirementPlanIndex) {
      this.onPlanSelect({
        name: this.state.retirementPlanIndex,
        label: config.plansSource[this.state.retirementPlanIndex].short_name
      })
    }
  }
  // 
  componentWillReceiveProps(props) {
    if (props.retirementPlanIndex && props.retirementPlanIndex !== this.state.retirementPlanIndex) {
      // pass
      console.log('componentWillReceiveProps pass')
    } else if (props.retirementPlanIndex && props.retirementPlanIndex !== this.state.retirementPlanIndex) {
      this.onPlanSelect({
        name: props.retirementPlanIndex,
        label: config.plansSource[props.retirementPlanIndex].short_name
      })
    } else if (!props.retirementPlanIndex && this.state.planSelected.name !== 'Select a plan') {
      this.onPlanSelect({
        name: 'Select a plan',
        label: 'Select a plan'
      })
    }
  }
  //
  onPlanSelect = (val) => {
    // clear the timeout
    // this is in case user changes select before prev
    // timeout has finished
    if (this.state.planTimeout) {
      clearTimeout(this.state.planTimeout)
    }
    const timeoutLen = 500
    //
    if (val) {
      // if we selected a value:
      // set the state so that the selected value is on the select
      // so that the loading icon is showing
      // so that nothing is open
      // and start a timeout for 1 second
      // after 1 second, hide the loading icon
      // and open the results
      scroller.scrollTo('scroll-to-plan', 0, 0)
      this.setState({
        planSelected: val,
        planLoading: true,
        planTimeout: setTimeout(()=>{
          scroller.scrollTo('scroll-to-plan', 0, 0)
          if (val.name !== this.state.retirementPlanIndex) {
            const cntxt = {
              pathname: config.routes.retirementPlans
            }
            if (val.name && val.name !== 'Select a plan' && val.name !== 'Select+a+plan') {
              cntxt.pathname = cntxt.pathname + '/' + val.name
            }
            this.context.router.push(cntxt)
          }
          this.setState({
            planLoading: false,
            retirementPlanIndex: val.name,
          })
        }, timeoutLen)
      })
    } else {
      // if didn't select a value
      // set selected value to default option
      // set loading icon to off
      // nothing should be showing
      // and there is no timeout.
      scroller.scrollTo('scroll-to-plan', 0, 0)
      this.setState({
        planSelected: { name: 'Select a plan', label: 'Select a plan' },
        planLoading: true,
        planTimeout: setTimeout(()=>{
          scroller.scrollTo('scroll-to-plan', 0, 0)
          this.context.router.push({
            pathname: config.routes.retirementPlans,
          })
          this.setState({
            planLoading: false,
            retirementPlanIndex: null
          })
        }, timeoutLen)
      })
    }
  }
  //
  render() {
    // select active plan
    let activePlan = null
    if (this.state.planSelected.name !== 'Select a plan') {
      activePlan = this.state.plansData.find(
        (plan) => { return this.state.planSelected.name === plan.key }
      )
    }
    //
    return <div id='retirement-plans'>
      <div styleName='plan-select-wrap'>
        <ContainerDivs>
          <h2>Retirement plans</h2>
          <h3 styleName='select-dropdown-plan-label'>
            Search by employer
          </h3>
          <div styleName='select-dropdown-plan-wrap'>
            <SelectDropdownPlan
              plans={config.plansBondsSource}
              value={this.state.planSelected}
              onChange={this.onPlanSelect}
            />
          </div>
          <div id='scroll-to-plan'/>
          <PlanTableLayout
            planLoading={this.state.planLoading}
            plansData={this.state.plansData}
            activePlan={activePlan}
            onPlanSelect={this.onPlanSelect}
          />
        </ContainerDivs>
      </div>
    </div>
  }
}


//
// <PlanTableLayout> component
//
// @param planLoading:
// @param activePlan:
// @param plansData:
// @param onPlanSelect:
//
@CSSModules(Styles, {allowMultiple:true})
class PlanTableLayout extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }
  //
  render() {
    return <div>
        <div styleName='hidden-xs hidden-sm'>
          <PlanTableDesktop
            planLoading={this.props.planLoading}
            plansData={this.props.plansData}
            activePlan={this.props.activePlan}
            onPlanSelect={this.props.onPlanSelect}
          />
        </div>
        <div styleName='hidden-md hidden-lg'>
          <PlanTableMobile
            planLoading={this.props.planLoading}
            plansData={this.props.plansData}
            activePlan={this.props.activePlan}
            onPlanSelect={this.props.onPlanSelect}
          />
        </div>
    </div>
  }
}


//
// <PlanTableDesktop> component
//
// @param planLoading:
// @param activePlan:
// @param plansData:
// @param onPlanSelect:
//
@CSSModules(Styles, {allowMultiple:true})
class PlanTableDesktop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounceTime: 500,
      sort: 'short_name',
      asc: true,
      plansData: props.plansData,
      loading: false,
      reloadingTimeout: null,
      activeFilter: 'mil',
      activeFilterLabel: null
    }
  }
  //
  clickPlanTableHeader = (c, isString=false, sameAsc=false) => {
    if (this.state.loading) { return }
    //
    const arr = this.state.plansData
    //
    // track if sort is ascending/descending
    let currAsc = this.state.asc
    if (c===this.state.sort && !sameAsc) {
      currAsc = !currAsc
    }
    //
    // sort strings
    if (isString) {
      arr.sort((a, b) => {
        // reverse sort if ascending/descending
        if (currAsc) {
          return a[c].localeCompare(b[c])
        } else {
          return b[c].localeCompare(a[c])
        }
      })
    } else {
      //
      // sort numbers
      arr.sort((a, b) => {
        // reverse sort if ascending/descending
        if (currAsc) {
          return a[c] > b[c]
        } else {
          return a[c] < b[c]
        }
      })
    }
    //
    // clear loading timeout
    if (this.reloadingTimeout) {
      clearTimeout(this.reloadingTimeout)
    }
    //
    // scroll to top if sorting
    scroller.scrollTo('scroll-to-plans', -10)
    //
    // set sort and ascending state, and loading
    // create timeout to end loading and set sorted results
    this.setState({
      asc: currAsc,
      sort: c,
      loading: true,
      reloadingTimeout: setTimeout(
        () => {
          this.setState({
            loading: false,
            plansData: arr,
          })
        },
        this.state.debounceTime
      )
    })
  }

  clickFilter = (filterCode) => {
    if (filterCode === this.state.activeFilter) { return }

    const filterLabel = {
      mil: 'All military weapons',
      nw:  'Nuclear weapons',
      cm:  'Controversial weapons',
    }[filterCode]

    this.setState({
      activeFilter: filterCode,
      activeFilterLabel: filterLabel
    })

    // only isString if sort is plan_short_name
    // only sameAsc if sorting from clickFilter
    let newSort = this.state.sort.replace('_mil_', '_'+filterCode+'_')
    newSort = newSort.replace('_nw_', '_'+filterCode+'_')
    newSort = newSort.replace('_cm_', '_'+filterCode+'_')
    const isString = (newSort === 'plan_short_name')
    const sameAsc = (newSort===this.state.sort)
    this.clickPlanTableHeader(newSort, isString, sameAsc)
  }
  //
  render() {
    return <div style={{'minHeight': '2000px'}}>

      { /* LOADING ICON DURING PLAN SELECT TIMEOUT */
        this.props.planLoading || this.state.loading ?
          <div styleName='plan-loader-wrap'>
            <Loader
              options={{ scale: 0.70, top: '200px' }}
              loaded={false}
            />
          </div> :
          null
      }

      {
        /* LIST OF PLANS*/
        !this.props.planLoading && !this.props.activePlan ?
          <div>
            <br/>
            <br/>
            <br/>
            <div styleName='plan-list-info-wrap'>
              <div>
                <h3 styleName=''>
                  Sort by weapon investments
                </h3>
                <p>
                  Filter to show all investments in military weapon manufacturers, or just companies involved in nuclear or controversial weapons.
                </p>
              </div>
              <div styleName='plan-list-info'>
                <p>
                  <LinkIcon faclass='fa-info-circle fa-2x' nospace/>&nbsp;&nbsp;&nbsp;<i>Definitions</i>
                </p>
                <ul>
                  <li>
                    <b>Exposure:</b> The % of plan assets invested in weapon stocks or bonds.
                  </li>
                  <li>
                    <b>Investments:</b> The amount in USD$ that plan participants have invested in weapon stocks or bonds.
                  </li>
                </ul>
              </div>
            </div>
            <div id='scroll-to-plans'/>
            <div styleName='sticky-table-header'>
              <FilterButtons activeFilter={this.state.activeFilter} clickFilter={this.clickFilter} />
              <div styleName='plan-list-row-header'>
                { /* <div styleName='plan-list-row-header-row-header'>
                  <div>
                    Showing: <b>{this.state.activeFilterLabel || 'All military weapon investments'}</b>
                  </div>
                </div> */ }
                <div styleName='plan-list-row-header-row-header'>
                  <div>
                    &nbsp;
                  </div>
                  <div>
                    <b>Stocks</b>
                  </div>
                  <div>
                    <b>Bonds</b>
                  </div>
                  <div>
                    <b>TOTAL</b>
                  </div>
                </div>
                <div styleName='plan-list-row-header-row'>
                  {
                    [
                      ['short_name','Employer'],
                      ['wff_'+this.state.activeFilter+'_weight_equity','Exposure'],
                      ['wff_'+this.state.activeFilter+'_asset_equity','Investments'],
                      ['wff_'+this.state.activeFilter+'_weight_bond','Exposure'],
                      ['wff_'+this.state.activeFilter+'_asset_bond','Investments'],
                      ['wff_'+this.state.activeFilter+'_weight_both','Exposure'],
                      ['wff_'+this.state.activeFilter+'_asset_both','Investments'],
                    ].map((pre, pri) => {
                      return <div
                        styleName={this.state.sort === pre[0] ? 'plan-list-row-header-th-active' : ''}
                        onClick={() => {
                          this.clickPlanTableHeader(pre[0], (pri === 0))
                        }}
                      >
                        { pri > 0 ? <i>{pre[1]}</i> : pre[1] }
                        {
                          this.state.sort === pre[0] ?
                            (
                              this.state.asc ?
                                <LinkIcon faclass='fa-caret-down'/> :
                                <LinkIcon faclass='fa-caret-up'/>
                            ) :
                            null
                        }
                      </div>
                    })
                  }
                </div>
              </div>
            </div>
            <div styleName='plan-list'>
              {
                this.state.plansData.map((plan, planI) => {
                  return <div key={'plan-list-row-'+planI}>
                    <div
                      styleName='plan-list-row'
                      key={'plan-select-list-'+planI}
                      onClick={() => {
                        this.props.onPlanSelect({
                          name: plan.key,
                          label: plan.short_name
                        })
                      }}
                    >
                      <div styleName='plan-list-logo-wrap'>
                        { /* <img
                          src={plan.logo}
                          alt={plan.short_name}
                          styleName='plan-list-logo'
                        />
                        <SrOnly>{plan.short_name}</SrOnly> */ }
                        {plan.short_name}
                      </div>
                      <div>
                        { fp(plan['wff_'+this.state.activeFilter+'_weight_equity']) }
                      </div>
                      <div>
                        { fm(plan['wff_'+this.state.activeFilter+'_asset_equity']) }
                      </div>
                      <div>
                        { fp(plan['wff_'+this.state.activeFilter+'_weight_bond']) }
                      </div>
                      <div>
                        { fm(plan['wff_'+this.state.activeFilter+'_asset_bond']) }
                      </div>
                      <div>
                        { fp(plan['wff_'+this.state.activeFilter+'_weight_both']) }
                      </div>
                      <div>
                        <span styleName='red h2'><b>{ fm(plan['wff_'+this.state.activeFilter+'_asset_both']) }</b></span>
                      </div>
                    </div>
                  </div>
                })
              }
            </div>
          </div> :
          null
      }

      <PlanResults
        planLoading={this.props.planLoading}
        activePlan={this.props.activePlan}
        onPlanSelect={this.props.onPlanSelect}
      />
    </div>
  }
}


//
// <PlanTableMobile> component
//
// @param planLoading:
// @param activePlan:
// @param plansData:
// @param onPlanSelect:
//
@CSSModules(Styles, {allowMultiple:true})
class PlanTableMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounceTime: 500,
      sort: 'short_name',
      asc: true,
      plansData: props.plansData,
      loading: false,
      reloadingTimeout: null,
      activeFilter: 'mil',
      activeFilterLabel: 'All military weapons'
    }
  }

  // not sorting now but might if we add sort
  // clickPlanTableHeader = (c, isString=false, sameAsc=false) => {
  //   if (this.state.loading) { return }
  //   //
  //   const arr = this.state.plansData
  //   //
  //   // track if sort is ascending/descending
  //   let currAsc = this.state.asc
  //   if (c===this.state.sort && !sameAsc) {
  //     currAsc = !currAsc
  //   }
  //   //
  //   // sort strings
  //   if (isString) {
  //     arr.sort((a, b) => {
  //       // reverse sort if ascending/descending
  //       if (currAsc) {
  //         return a[c].localeCompare(b[c])
  //       } else {
  //         return b[c].localeCompare(a[c])
  //       }
  //     })
  //   } else {
  //     //
  //     // sort numbers
  //     arr.sort((a, b) => {
  //       // reverse sort if ascending/descending
  //       if (currAsc) {
  //         return a[c] > b[c]
  //       } else {
  //         return a[c] < b[c]
  //       }
  //     })
  //   }
  //   //
  //   // clear loading timeout
  //   if (this.reloadingTimeout) {
  //     clearTimeout(this.reloadingTimeout)
  //   }
  //   //
  //   // scroll to top if sorting
  //   // scroller.scrollTo('scroll-to-plans', -10)
  //   //
  //   // set sort and ascending state, and loading
  //   // create timeout to end loading and set sorted results
  //   this.setState({
  //     asc: currAsc,
  //     sort: c,
  //     loading: true,
  //     reloadingTimeout: setTimeout(
  //       () => {
  //         this.setState({
  //           loading: false,
  //           plansData: arr,
  //         })
  //       },
  //       this.state.debounceTime
  //     )
  //   })
  // }
  //
  clickFilter = (filterCode) => {
    if (filterCode === this.state.activeFilter) { return }

    const filterLabel = {
      mil: 'All military weapons',
      nw:  'Nuclear weapons',
      cm:  'Controversial weapons',
    }[filterCode]

    this.setState({
      activeFilter: filterCode,
      activeFilterLabel: filterLabel
    })

    // // only isString if sort is plan_short_name
    // // only sameAsc if sorting from clickFilter
    // let newSort = this.state.sort.replace('_mil_', '_'+filterCode+'_')
    // newSort = newSort.replace('_nw_', '_'+filterCode+'_')
    // newSort = newSort.replace('_cm_', '_'+filterCode+'_')
    // const isString = (newSort === 'plan_short_name')
    // const sameAsc = (newSort===this.state.sort)
    // this.clickPlanTableHeader(newSort, isString, sameAsc)
  }
  //
  opener(rowLabel) {
    const newState = {}
    newState[rowLabel] = !this.state[rowLabel]
    this.setState(newState)
  }
  //
  render() {
    return <div style={{'minHeight': '2000px'}}>

      { /* LOADING ICON DURING PLAN SELECT TIMEOUT */
        this.props.planLoading || this.state.loading ?
          <div styleName='plan-loader-wrap'>
            <Loader
              options={{ scale: 0.70, top: '200px' }}
              loaded={false}
            />
          </div> :
          null
      }

      {
        /* LIST OF PLANS*/
        !this.props.planLoading && !this.props.activePlan ?
          <div>
            <div styleName='plan-list-info-wrap'>
              <h3>
                Retirement plan weapon investments
              </h3>
              <p>
                Filter to show all investments in military weapon manufacturers, or just companies involved in nuclear or controversial weapons.
              </p>
              { /* <div styleName='plan-list-info'>
                <p>
                  <LinkIcon faclass='fa-info-circle fa-2x' nospace/>&nbsp;&nbsp;&nbsp;<i>Definitions</i>
                </p>
                <ul>
                  <li>
                    <b>Exposure:</b> The % of plan assets invested in weapon stocks or bonds.
                  </li>
                  <li>
                    <b>Investments:</b> The amount in USD$ that plan participants have invested in weapon stocks or bonds.
                  </li>
                </ul>
              </div> */ }
            </div>

            <div>
              <div id='scroll-to-plans'/>
              <div styleName='sticky-table-header'>
                <FilterButtons activeFilter={this.state.activeFilter} clickFilter={this.clickFilter} />
              </div>
              <div styleName='plan-list'>

                <div>
                  <div styleName='plan-list-row' >
                    <div styleName='plan-list-logo-wrap'>
                      Plan name
                    </div>
                    <div>
                      <span><b>Investments:</b><br/>{this.state.activeFilterLabel}</span>
                    </div>
                  </div>
                </div>

                {
                  this.state.plansData.map((plan, planI) => {
                    return <div key={'plan-list-row-'+planI}>
                      <div
                        styleName='plan-list-row'
                        onClick={() => {
                          this.props.onPlanSelect({
                            name: plan.key,
                            label: plan.short_name
                          })
                        }}
                      >
                        <div styleName='plan-list-logo-wrap'>
                          {plan.short_name}
                        </div>
                        <div>
                          <span styleName='red h2'><b>{ fm(plan['wff_'+this.state.activeFilter+'_asset_both']) }</b></span>
                        </div>
                      </div>
                    </div>
                  })
                }
              </div>
            </div>
          </div> :
          null
      }

      <PlanResults
        planLoading={this.props.planLoading}
        activePlan={this.props.activePlan}
        onPlanSelect={this.props.onPlanSelect}
      />
    </div>
  }
}


//
// <PlanResults> component
//
@CSSModules(Styles, {allowMultiple:true})
class PlanResults extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }
  //
  render() {
    return !this.props.planLoading && this.props.activePlan ?
      <div styleName='plan-summary-wrap' id={this.props.activePlan.key}>
        <div
          styleName='plan-summary-back-to-list'
          onClick={() => {
            this.props.onPlanSelect({
              name: 'Select a plan',
              label: 'Select a plan'
            })
          }}
        >
          <LinkIcon nospace faclass='fa-arrow-left'/>
          &nbsp;
          Back to list
        </div>
        <PlanSummary activePlan={this.props.activePlan}/>
        <PlanCharts activePlan={this.props.activePlan}/>
        <PlanOptionsTableLayout activePlan={this.props.activePlan}/>
        <div
          styleName='plan-summary-back-to-list'
          onClick={() => {
            this.props.onPlanSelect({
              name: 'Select a plan',
              label: 'Select a plan'
            })
          }}
        >
          <LinkIcon nospace faclass='fa-arrow-left'/>
          &nbsp;
          Back to list
        </div>
      </div> :
      null
  }
}


//
// <FilterButtons> component
//
@CSSModules(Styles, {allowMultiple:true})
class FilterButtons extends Component {
  constructor(props) {
    super(props)
    this.state = { showDesc: false }
  }
  //
  render() {
    const iconMil = require( '../../../static/images/icn-mmc-no-circle-white.svg' )
    const iconNw = require( '../../../static/images/icn-nw-no-circle-white.svg' )
    const iconCm = require( '../../../static/images/icn-cm-no-circle-white.svg' )
    //
    return <div>
      <div styleName='filter-buttons-wrap'>
        <button
          styleName={'top-holding-table-filter-btn ' + (this.props.activeFilter === 'mil' || this.props.activeFilter === null ? 'active-filter-btn' : '')}
          onClick={() => { this.props.clickFilter('mil') }}
        >
          <img
            src={iconMil}
            alt='All military weapons'
            styleName='filter-icn'
          />
          All military weapons
        </button>
        <button
          styleName={'top-holding-table-filter-btn ' + (this.props.activeFilter === 'nw' ? 'active-filter-btn' : '')}
          onClick={() => { this.props.clickFilter('nw') }}
        >
          <img
            src={iconNw}
            alt='Nuclear weapons'
            styleName='filter-icn'
          />
          Nuclear
        </button>
        <button
          styleName={'top-holding-table-filter-btn ' + (this.props.activeFilter === 'cm' ? 'active-filter-btn' : '')}
          onClick={() => { this.props.clickFilter('cm') }}
        >
          <img
            src={iconCm}
            alt='Controversial weapons'
            styleName='filter-icn'
          />
          Controversial
        </button>
        <button
          styleName='filter-btn-info'
          onClick={() => { this.setState({showDesc: !this.state.showDesc }) }}
        >
          <LinkIcon nospace faclass='fa-info-circle' />
        </button>
      </div>
      <SlideDown>
        {
          this.state.showDesc && (this.props.activeFilter === 'mil' || this.props.activeFilter === null) ?
            <div styleName='filter-info-content'>
              <b>All military weapons</b> — Arms manufacturers and military contractors fuel global warfare through the international arms trade. Concerns about human rights, social impact, reputation risk, and regulatory risks are just a few of the reasons companies like these are avoided by sustainable investors.
            </div>:
            null
        }
        {
          this.state.showDesc && this.props.activeFilter === 'nw' ?
            <div styleName='filter-info-content'>
              <b>Nuclear weapons</b> — The financing of companies contributing to the build-up and modernization of nuclear arms undermines efforts to achieve nuclear disarmament. Any use of nuclear weapons would violate fundamental rules of international law and have catastrophic humanitarian and environmental consequences.
            </div>:
            null
        }
        {
          this.state.showDesc && this.props.activeFilter === 'cm' ?
            <div styleName='filter-info-content'>
              <b>Controversial weapons</b> — Weapons like cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium are particularly controversial because of their indiscriminate impacts. These weapons are banned by hundreds of countries under various treaties.
            </div>:
            null
        }
      </SlideDown>
    </div>
  }
}


//
// <PlanSummary> component
// Layout for plan summary, including desktop/tablet and mobile
// Includes: <PlanSummaryLogo>,
//           <PlanSummaryNameSize>,
//           <PlanSummaryTopWeaponBondHoldIngs>,
//           <PlanSummaryWeaponInvestments>
// @param activePlan: Object of active plan from <PlanSelect>
//
@CSSModules(Styles, {allowMultiple:true})
class PlanSummary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeFilter: 'mil'
    }
  }
  //
  clickFilter = (filterCode) => {
    this.setState({
      activeFilter: filterCode
    })
  }
  //
  render() {
    if (!this.props.activePlan) { return null }
    return (
      <div>

        <Row>
          <Col xs={12} sm={6}>
            <PlanSummaryNameSize activePlan={this.props.activePlan}/>
          </Col>
          <Col xs={12} sm={6}>
            <PlanSummaryLogo activePlan={this.props.activePlan}/>
          </Col>
        </Row>

        <h3 styleName='plan-options-section-heading'>Top military weapon holdings</h3>

        <FilterButtons activeFilter={this.state.activeFilter} clickFilter={this.clickFilter} />

        { /* DESKTOP LAYOUT */ }
        <div styleName='hidden-xs'>
          <Row>
            <Col xs={12} sm={6}>
              <PlanSummaryTopWeaponBondHoldIngs activeFilter={this.state.activeFilter} isEquity activePlan={this.props.activePlan}/>
            </Col>
            <Col xs={12} sm={6}>
              <PlanSummaryWeaponInvestments activeFilter={this.state.activeFilter} isEquity activePlan={this.props.activePlan} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <PlanSummaryTopWeaponBondHoldIngs activeFilter={this.state.activeFilter} activePlan={this.props.activePlan}/>
            </Col>
            <Col xs={12} sm={6}>
              <PlanSummaryWeaponInvestments activeFilter={this.state.activeFilter} activePlan={this.props.activePlan}/>
            </Col>
          </Row>
        </div>

        { /* MOBILE LAYOUT */ }
        <div styleName='visible-xs'>
          <PlanSummaryTopWeaponBondHoldIngs activeFilter={this.state.activeFilter} isEquity activePlan={this.props.activePlan}/>
          <PlanSummaryWeaponInvestments activeFilter={this.state.activeFilter} isEquity activePlan={this.props.activePlan} showDefinitions/>
          <PlanSummaryTopWeaponBondHoldIngs activeFilter={this.state.activeFilter} activePlan={this.props.activePlan}/>
          <PlanSummaryWeaponInvestments activeFilter={this.state.activeFilter} activePlan={this.props.activePlan}/>
        </div>

      </div>
    )
  }
}


//
// <PlanSummaryLogo> component
// Display: image of plan logo
// @param activePlan: Object of active plan from <PlanSelect>
//
@CSSModules(Styles, {allowMultiple:true})
class PlanSummaryLogo extends Component {
  render() {
    if (!this.props.activePlan) { return null }
    return (
      <div styleName='plan-summary-col'>
        <h3 styleName='plan-summary-section-heading'>
          EMPLOYER
        </h3>
        <img
          src={this.props.activePlan.logo}
          alt={this.props.activePlan.short_name}
          styleName='plan-summary-logo'
        />
      </div>
    )
  }
}


//
// <PlanSummaryNameSize> component
// Display: name, size of plan
// @param activePlan: Object of active plan from <PlanSelect>
//
@CSSModules(Styles, {allowMultiple:true})
class PlanSummaryNameSize extends Component {
  constructor(props) { super(props) }
  render() {
    if (!this.props.activePlan) { return null }
    return (
      <div>
        <div styleName='plan-summary-col'>
          <h3 styleName='plan-summary-section-heading'>
            PLAN NAME
          </h3>
          <p>
            {this.props.activePlan.primary_plan_name}
          </p>
        </div>
        <div styleName='plan-summary-col'>
          <h3 styleName='plan-summary-section-heading'>
            PLAN SIZE
          </h3>
          <p>
            { fm(this.props.activePlan.plan_assets) } invested
            in {this.props.activePlan.plan_option_count} plan options
          </p>
        </div>
      </div>
    )
  }
}


//
// <PlanSummaryTopWeaponBondHoldIngs> component
// Display: table of top arms manufacturer bond holdings
// @param activePlan: Object of active plan from <PlanSelect>
//
@CSSModules(Styles, {allowMultiple:true})
class PlanSummaryTopWeaponBondHoldIngs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      label: (props.isEquity ?
                'Stocks' :
                'Corporate bonds'),
    }
  }
  //
  getCompaniesKey = () => {
    let cL = 'top_wff_'
    cL += this.props.activeFilter ? this.props.activeFilter + '_' : ''
    cL += this.props.isEquity ? 'equity' : 'cbond'
    cL += '_companies_in_plan'
    return cL
  }
  //
  getFilterLabel = (c) => {
    return {
      mil: 'All military weapons',
      nw: 'Nuclear weapons',
      cm: 'Controversial weapons',
    }[c] || 'ERR'
  }
  //
  render() {
    if (!this.props.activePlan) { return null }
    //
    const iconNw = require( '../../../static/images/icn-nw-no-circle-black.svg' )
    const iconCm = require( '../../../static/images/icn-cm-no-circle-black.svg' )
    //
    return <div styleName='plan-summary-col'>
      <h3 styleName='top-companies-section-heading'>
        { this.state.label } - { this.getFilterLabel(this.props.activeFilter) }
      </h3>
      <div styleName='top-companies-ol'>
        {
          this.props.activePlan[this.getCompaniesKey()].map((c, i2)=>{
            return <div
              key={'top_cbond_companies_'+this.props.activePlan.key+'_'+i2}
              styleName={'top-companies-li'}
            >
              <CompanyProfileModal holding={{company_id: c[2]}}>
                <div styleName='top-companies-li-flex'>
                  <div>
                    {
                      this.props.activeFilter === 'nw' ?
                        <img src={iconNw} alt='Nuclear weapons' /> :
                        null
                    }
                    {
                      this.props.activeFilter === 'cm' ?
                        <img src={iconCm} alt='Controversial weapons' /> :
                        null
                    }
                    {
                      this.props.activeFilter === 'mil' ?
                        <div/> :
                        null
                    }
                    {i2 + 1}.
                  </div>
                  <div>{c[0]}</div>
                  <div>{fm(c[1])}</div>
                </div>
              </CompanyProfileModal>
            </div>
          })
        }
      </div>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class PlanSummaryWeaponInvestments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      label: (props.isEquity ?
                'Stocks' :
                'Corporate bonds'),
    }
  }
  //
  getV = () => {
    const prefix = this.props.activeFilter ? 'wff_' + this.props.activeFilter : 'wff_mil'
    return {
      'plan_assets': this.props.activePlan.plan_assets,
      'long_assets': this.props.activePlan[this.props.isEquity ? 'long_equity_assets' : 'long_cbond_assets'],
      'asset':  this.props.activePlan[prefix + '_asset_' +  (this.props.isEquity ? 'equity' : 'bond')],
      'weight': this.props.activePlan[prefix + '_weight_' + (this.props.isEquity ? 'equity' : 'bond')],
      'concentration': this.props.activePlan[prefix + '_weight_' + (this.props.isEquity ? 'equity' : 'bond') + '_concentration']
    }
  }
  //
  render() {
    if (!this.props.activePlan) { return null }
    const v = this.getV()
    const concentrationTooltip = `Concentration is the investment amount compared to the ${fm(v.long_assets)} invested in ${this.state.label.toLowerCase()} by the various plan options.`
    const concentrationTooltipId = this.state.label.toLowerCase().replace(' ','')+this.props.activeFilter+'tooltip-c'
    const exposureTooltip = `Exposure is the investment amount compared to the total amount of ${fm(v.plan_assets)} invested across all plan options.`
    const exposureTooltipId = this.state.label.toLowerCase().replace(' ','')+this.props.activeFilter+'tooltip-e'
    //
    return <div styleName='fossil-fuel-investments-summary-wrap'>
      <div styleName='plan-summary-col'>
        <div>
          <p styleName='plan-summary-section-heading-empty' style={{'color':'transparent'}}>
            {this.state.label}
          </p>
          {
            this.props.showDefinitions ?
              <div styleName='plan-list-info'>
                <p>
                  <LinkIcon faclass='fa-info-circle fa-2x' nospace/>&nbsp;&nbsp;&nbsp;<i>Definitions</i>
                </p>
                <ul>
                  <li>
                    <b>Investments:</b> The amount in USD$ that plan participants have invested in weapon stocks or bonds.
                  </li>
                  <li>
                    <b>Exposure:</b> The % of overall plan assets invested in weapon stocks or bonds.
                  </li>
                  <li>
                    <b>Concentration:</b> The % of bond assets or stock assets that are invested in weapon stocks or bonds.
                  </li>
                </ul>
              </div> :
              null
          }
          <div styleName='plan-summary-stat-flex'>
            <div>
              Investments
            </div>
            <div>
              { fm(v.asset) }
            </div>
          </div>
          <div styleName='plan-summary-stat-flex'>
            <div>
              <span styleName='visible-xs'>
                Exposure
              </span>
              <span
                styleName='hidden-xs'
                style={{'cursor':'pointer'}}
                data-multiline
                data-effect='solid'
                data-tip={exposureTooltip}
                data-html
                data-place='left'
                data-for={exposureTooltipId}
              >Exposure<LinkIcon faclass='fa-info-circle' /></span>
            </div>
            <div>
              { fp(v.weight) }
            </div>
          </div>
          <div styleName='plan-summary-stat-flex'>
            <div>
              <span styleName='visible-xs'>
                Concentration
              </span>
              <span
                styleName='hidden-xs'
                style={{'cursor':'pointer'}}
                data-multiline
                data-effect='solid'
                data-tip={concentrationTooltip}
                data-html
                data-place='left'
                data-for={concentrationTooltipId}
              >Concentration<LinkIcon faclass='fa-info-circle' /></span>
            </div>
            <div>
              <span styleName='red'>{ fp(v.concentration) }</span>
            </div>
          </div>
        </div>
      </div>

      <ReactTooltip id={concentrationTooltipId}/>
      <ReactTooltip id={exposureTooltipId}/>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class PlanCharts extends Component {
  constructor(props) {
    super(props)
    const { activePlan } = this.props
    const urlPrefix = 'https://iyv-charts.s3-us-west-2.amazonaws.com/military_weapon_bonds/'
    const planWeightChartUrl = `${urlPrefix}${activePlan.primary_plan_name} military weapon bonds weight ${currYYYYMM}.png`
    const planWeightChartAlt = `${activePlan.primary_plan_name} weight chart`
    const planAssetChartUrl = `${urlPrefix}${activePlan.primary_plan_name} military weapon bonds assets ${currYYYYMM}.png`
    const planAssetChartAlt = `${activePlan.primary_plan_name} assets chart`
    this.state = {
      isAssetChart: null,
      planWeightChartUrl,
      planWeightChartAlt,
      planAssetChartUrl,
      planAssetChartAlt,
    }
  }
  //
  render() {
    return <div styleName='plan-charts-wrap'>
      <Row>
        <Col xs={12} sm={8}>
          <h3 styleName='plan-options-section-heading'>
            Plan investment options
          </h3>
          <p>
            Sort plan investment options
            by each fund's %
            exposure to arms manufacturers, or
            the USD$ amount that plan participants have invested in
            arms manufacturers via each fund.
          </p>
        </Col>
        <Col xs={12} sm={4}>
          <div styleName='chart-button-flex-wrap'>
            <div styleName='chart-button-flex-cell'>
              <div styleName='chart-button-label-flex'>
                <i>Chart type</i>
              </div>
              <div styleName='chart-button-flex'>
                <label styleName="toggle">
                  <span styleName='toggle-label'>Percent</span>
                  <input
                    styleName='toggle-checkbox'
                    type='checkbox'
                    checked={this.state.isAssetChart}
                    onClick={()=>{
                      this.setState({
                        isAssetChart: !this.state.isAssetChart
                      })
                    }}
                  />
                  <div styleName='toggle-switch'></div>
                  <span styleName='toggle-label'>USD $</span>
                </label>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      { /* CHART IMAGE 1 - BY WEIGHT */
        !this.state.isAssetChart ?
          <div>
            <h3 styleName='chart-title'>
              Plan options by % exposure to arms
              manufacturer stocks and bonds
            </h3>
            <div styleName='chart-img-wrap'>
              <Link
                to={this.state.planWeightChartUrl}
                title={this.state.planWeightChartAlt}
                targetBlank
              >
                <img
                  src={this.state.planWeightChartUrl}
                  alt={this.state.planWeightChartAlt}
                  styleName='chart-img'
                />
                <span styleName='chart-expand-label visible-xs'>
                  Click to enlarge<LinkIcon faclass='fa-expand'/>
                </span>
              </Link>
            </div>
            <p styleName='chart-disclaimer'>
              <LinkIcon nospace faclass='fa-info-circle'/>
              &nbsp;This chart shows the percent of each
              plan option that is invested in arms manufacturer
              stocks and bonds. The plan options
              at the top of the chart have the most
              exposure to arms manufacturers,
              and the plan options at the bottom of
              the chart have the least exposure.
            </p>

          </div> :
          /* CHART IMAGE 2 - BY ASSET */
          <div>
            <h3 styleName='chart-title'>
              Plan options by USD$ invested in arms
              manufacturers by plan participants
            </h3>
            <div styleName='chart-img-wrap'>
              <Link
                to={this.state.planAssetChartUrl}
                title={this.state.planAssetChartAlt}
                targetBlank
              >
                <img
                  src={this.state.planAssetChartUrl}
                  alt={this.state.planAssetChartAlt}
                  styleName='chart-img'
                />
                <span styleName='chart-expand-label visible-xs'>
                  Click to enlarge<LinkIcon faclass='fa-expand'/>
                </span>
              </Link>
            </div>
            <p styleName='chart-disclaimer'>
              <LinkIcon nospace faclass='fa-info-circle'/>
              &nbsp;This chart shows, for each plan option
              in the retirement plan,
              the amount in USD invested
              in arms manufacturer stocks and bonds
              by plan participants via that fund.
              The plan options at the top of
              the chart account for the most money
              invested in arms manufacturer stocks and bonds
              by plan participants, and the plan options
              at the bottom of the chart account
              for the least.
              In total, plan participants have {
                fm(this.props.activePlan.wff_mil_asset_both)
              } invested in arms manufacturers via these
              plan options.
            </p>
          </div>
      }
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class PlanOptionsTableLayout extends Component {
  constructor(props) {
    super(props)
  }
  //
  render() {
    if (!this.props.activePlan) { return null }
    return (
      <div styleName='plan-options-table-wrap'>
        <div styleName='plan-list-info-wrap'>
          <div>
            <h3>
              Plan option weapon investment totals
            </h3>
            <p>
              Filter to show all investments in military weapon manufacturers, or just companies involved in nuclear or controversial weapons.
            </p>
          </div>
          <div styleName='plan-list-info hidden-xs hidden-sm'>
            <p>
              <LinkIcon faclass='fa-info-circle fa-2x' nospace/>&nbsp;&nbsp;&nbsp;<i>Definitions</i>
            </p>
            <ul>
              <li>
                <b>Exposure:</b> The % of the fund's portfolio invested in weapon stocks or bonds.
              </li>
              <li>
                <b>Investments:</b> The amount in USD$ that plan participants have invested in weapon stocks or bonds via each plan option.
              </li>
            </ul>
          </div>
        </div>

        { /* DESKTOP LAYOUT*/ }
        <div styleName='hidden-xs hidden-sm'>
          <PlanOptionsTableDesktop activePlan={this.props.activePlan}/>
        </div>
        
        { /* MOBILE LAYOUT*/ }
        <div styleName='hidden-md hidden-lg'>
          <PlanOptionsTableMobile activePlan={this.props.activePlan}/>
        </div>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class PlanOptionsTableDesktop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounceTime: 500,
      sort: 'plan_option_name',
      asc: true,
      planOptionsData: props.activePlan && props.activePlan.plan_options_table ? props.activePlan.plan_options_table : [],
      loading: false,
      reloadingTimeout: null,
      activeFilter: 'mil'
    }
  }
  //
  clickFilter = (filterCode) => {
    if (filterCode === this.state.activeFilter) { return }
 
    this.setState({
      activeFilter: filterCode
    })

    const _filterCode = filterCode
    let newSort = this.state.sort.replace('_mil_', '_'+_filterCode+'_')
    newSort = newSort.replace('_nw_', '_'+_filterCode+'_')
    newSort = newSort.replace('_cm_', '_'+_filterCode+'_')
    const isString = (newSort === 'plan_short_name' || newSort === 'ticker')
    const sameAsc = (newSort===this.state.sort)
    this.clickPlanOptionsTableHeader(newSort, isString, sameAsc)
  }
  //
  clickPlanOptionsTableHeader = (c, isString=false, sameAsc=false) => {
    // const [0plan_option_name,
    //        1ticker,
    //        2fund_id,
    //        3investment_vehicle_id,
    //        4market_value,
    //        5ff_all_weight_equity,
    //        6ff_all_asset_equity,
    //        7ff_all_weight_bond,
    //        8ff_all_asset_bond,
    //        9ff_all_weight_both,
    //        10ff_all_asset_both,
    //        11wff_mil_weight_equity,
    //        12wff_mil_asset_equity,
    //        13wff_mil_weight_bond,
    //        14wff_mil_asset_bond,
    //        15wff_mil_weight_both,
    //        16wff_mil_asset_both,
    //        17wff_cluster_munitions_weight_equity,
    //        18wff_cluster_munitions_asset_equity,
    //        19wff_cluster_munitions_weight_bond,
    //        20wff_cluster_munitions_asset_bond,
    //        21wff_cluster_munitions_weight_both,
    //        22wff_cluster_munitions_asset_both,
    //        23wff_nuclear_weapons_weight_equity,
    //        24wff_nuclear_weapons_asset_equity,
    //        25wff_nuclear_weapons_weight_bond,
    //        26wff_nuclear_weapons_asset_bond,
    //        27wff_nuclear_weapons_weight_both,
    //        28wff_nuclear_weapons_asset_both] = o
    // ['plan_option_name', 'Plan option'],
    // ['ticker', 'Rated as'],
    // ['market_value', 'Market value'],
    // ['wff_mil_weight_equity', 'Exposure'],
    // ['wff_mil_asset_equity', 'Investments'],
    // ['wff_mil_weight_bond', 'Exposure'],
    // ['wff_mil_asset_bond', 'Investments'],
    // ['wff_mil_weight_both', 'Exposure'],
    // ['wff_mil_asset_both', 'Investments'],
    const cDict = {
      'plan_option_name' :      0,
      'ticker' :                1,
      'market_value' :          4,
      'wff_mil_weight_equity' : 11,
      'wff_mil_asset_equity' :  12,
      'wff_mil_weight_bond' :   13,
      'wff_mil_asset_bond' :    14,
      'wff_mil_weight_both' :   15,
      'wff_mil_asset_both' :    16,
      'wff_cm_weight_equity' :  17,
      'wff_cm_asset_equity' :   18,
      'wff_cm_weight_bond' :    19,
      'wff_cm_asset_bond' :     20,
      'wff_cm_weight_both' :    21,
      'wff_cm_asset_both' :     22,
      'wff_nw_weight_equity' :  23,
      'wff_nw_asset_equity' :   24,
      'wff_nw_weight_bond' :    25,
      'wff_nw_asset_bond' :     26,
      'wff_nw_weight_both' :    27,
      'wff_nw_asset_both' :     28,
    }
    let cI = null
    try {
      cI = cDict[c]
    } catch (error) {
      console.error(error);
      cI = 0
    }
    //
    if (this.state.loading) { return }
    //
    const arr = this.state.planOptionsData
    //
    // track if sort is ascending/descending
    let currAsc = this.state.asc
    if (c===this.state.sort && !sameAsc) {
      currAsc = !currAsc
    }
    //
    // sort strings
    if (isString) {
      arr.sort((a, b) => {
        // reverse sort if ascending/descending
        if (currAsc) {
          return a[cI].localeCompare(b[cI])
        } else {
          return b[cI].localeCompare(a[cI])
        }
      })
    } else {
      //
      // sort numbers
      arr.sort((a, b) => {
        // cast to number for unmatched funds
        let _a = a[cI]
        let _b = b[cI]
        if (['~', null].includes(a[cI])) {
          _a = 0
        }
        if (['~', null].includes(b[cI])) {
          _b = 0
        }
        // reverse sort if ascending/descending
        if (currAsc) {
          return parseFloat(_a) > parseFloat(_b)
        } else {
          return parseFloat(_a) < parseFloat(_b)
        }
      })
    }
    //
    // clear loading timeout
    if (this.reloadingTimeout) {
      clearTimeout(this.reloadingTimeout)
    }
    //
    // set sort and ascending state, and loading
    // create timeout to end loading and set sorted results
    // for (let i = 0; i < arr.length; i++) {
    //   console.log(arr[i][0], arr[i][cI])
    // } 

    scroller.scrollTo('scroll-to-plan-options')

    this.setState({
      asc: currAsc,
      sort: c,
      loading: true,
      reloadingTimeout: setTimeout(
        () => {
          this.setState({
            loading: false,
            planOptionsData: arr,
          })
        },
        this.state.debounceTime
      )
    })
  }
  //
  render() {
    if (!this.props.activePlan) { return null }
    //
    const { activePlan } = this.props
    //
    if (this.state.loading) {
      return <div styleName='plan-loader-wrap'>
        <Loader
          options={{ scale: 0.70, top: '200px' }}
          loaded={false}
        />
      </div>
    }
    //
    return <div>
      <div>
        <div id='scroll-to-plan-options'/>
        <div styleName='sticky-table-header'>
          <FilterButtons activeFilter={this.state.activeFilter} clickFilter={this.clickFilter} />
        </div>

        <table styleName='plan-options-table'>
          { /* FIRST THEAD */ }
          <thead styleName='sticky-table-thead'>
            <tr>
              <th colSpan='3' />
              <th colSpan='2'>
                <b>Stocks</b>
              </th>
              <th colSpan='2'>
                <b>Bonds</b>
              </th>
              <th colSpan='2'>
                <b>TOTAL</b>
              </th>
            </tr>
            <tr>
              { /* THEAD SECOND TR */
                [
                  ['plan_option_name', 'Plan option'],
                  ['ticker',           'Rated as'],
                  ['market_value',     'Market value'],
                  ['wff_'+this.state.activeFilter+'_weight_equity', 'Exposure'],
                  ['wff_'+this.state.activeFilter+'_asset_equity',  'Investments'],
                  ['wff_'+this.state.activeFilter+'_weight_bond',   'Exposure'],
                  ['wff_'+this.state.activeFilter+'_asset_bond',    'Investments'],
                  ['wff_'+this.state.activeFilter+'_weight_both',   'Exposure'],
                  ['wff_'+this.state.activeFilter+'_asset_both',    'Investments'],
                ].map((th, th_i) => {
                  const k = 'plan-option-table-th-'+th_i
                  return <th
                    styleName={'pointer ' + (this.state.sort === th[0] ? 'plan-option-table-th-active' : '')}
                    onClick={() => { this.clickPlanOptionsTableHeader(th[0], ([0, 1].includes(th_i)) ) }}
                    key={k}
                  >
                    { th_i > 2 ? <i>{th[1]}</i> : th[1] }
                    {
                      this.state.sort === th[0] ?
                        (
                          this.state.asc ?
                            <LinkIcon faclass='fa-caret-down'/> :
                            <LinkIcon faclass='fa-caret-up'/>
                        ) :
                        null
                    }
                  </th>
                })
              }
            </tr>
          </thead>
          <tbody>
            { /* MATCHED PLAN OPTIONS AS ROWS */
              /* FOR EACH PLAN OPTION... */
              this.state.planOptionsData.map((o, i3)=>{
                const [plan_option_name,
                       ticker,
                       fund_id,
                       investment_vehicle_id,
                       market_value,
                       ff_all_weight_equity,
                       ff_all_asset_equity,
                       ff_all_weight_bond,
                       ff_all_asset_bond,
                       ff_all_weight_both,
                       ff_all_asset_both,
                       wff_mil_weight_equity,
                       wff_mil_asset_equity,
                       wff_mil_weight_bond,
                       wff_mil_asset_bond,
                       wff_mil_weight_both,
                       wff_mil_asset_both,
                       wff_cm_weight_equity,
                       wff_cm_asset_equity,
                       wff_cm_weight_bond,
                       wff_cm_asset_bond,
                       wff_cm_weight_both,
                       wff_cm_asset_both,
                       wff_nw_weight_equity,
                       wff_nw_asset_equity,
                       wff_nw_weight_bond,
                       wff_nw_asset_bond,
                       wff_nw_weight_both,
                       wff_nw_asset_both] = o

                const rowObj = {
                  wff_mil_weight_equity,
                  wff_mil_asset_equity,
                  wff_mil_weight_bond,
                  wff_mil_asset_bond,
                  wff_mil_weight_both,
                  wff_mil_asset_both,
                  wff_cm_weight_equity,
                  wff_cm_asset_equity,
                  wff_cm_weight_bond,
                  wff_cm_asset_bond,
                  wff_cm_weight_both,
                  wff_cm_asset_both,
                  wff_nw_weight_equity,
                  wff_nw_asset_equity,
                  wff_nw_weight_bond,
                  wff_nw_asset_bond,
                  wff_nw_weight_both,
                  wff_nw_asset_both
                }

                // IF IT HAS NO FUND_ID, SKIP IT
                if (['~', 'FTSP00000G'].includes(fund_id)) {
                  return null
                }

                // IF FUND_ID, IT'S MATCHED
                // RETURN A ROW WITH MORE DATA
                const _k = 'plan-option-table-'+
                  'matched-option-'+i3
                return <tr key={_k} styleName='plan-option-table-row'>
                  { /* RETURN A <TD> WITH DATA */
                    [
                      plan_option_name,
                      ticker,
                      fm(market_value),
                      fp(rowObj['wff_'+this.state.activeFilter+'_weight_equity']),
                      fm(rowObj['wff_'+this.state.activeFilter+'_asset_equity'] ),
                      fp(rowObj['wff_'+this.state.activeFilter+'_weight_bond']  ),
                      fm(rowObj['wff_'+this.state.activeFilter+'_asset_bond']   ),
                      fp(rowObj['wff_'+this.state.activeFilter+'_weight_both']  ),
                      fm(rowObj['wff_'+this.state.activeFilter+'_asset_both']   ),
                    ].map((td, td_i) => {
                      const k = 'plan-option-table-'+
                        'matched-option-'+i3+'-'+td_i
                      let style = ''
                      if (td_i===0) { style = 'strong' }
                      if (td_i===8) { style = 'strong red h2' }
                      return <td key={k}>
                        <span styleName={style} >
                          {td}
                        </span>
                      </td>
                    })
                  }
                </tr>
              })
            }

            <tr styleName='table-total-row'>
              { /* TOTAL ROW FOR MATCHED FUNDS */
                [
                  'All matched funds',
                  null,
                  fm(activePlan.matched_fund_assets),
                  fp(activePlan['wff_'+this.state.activeFilter+'_weight_equity']),
                  fm(activePlan['wff_'+this.state.activeFilter+'_asset_equity'] ),
                  fp(activePlan['wff_'+this.state.activeFilter+'_weight_bond']  ),
                  fm(activePlan['wff_'+this.state.activeFilter+'_asset_bond']   ),
                  fp(activePlan['wff_'+this.state.activeFilter+'_weight_both']  ),
                  fm(activePlan['wff_'+this.state.activeFilter+'_asset_both']   ),
                ].map((td, td_i) => {
                  const k = 'plan-option-table-matched-totals-'+td_i
                  let style = ''
                  if (td_i===8) { style = 'strong h2' }
                  return <td key={k}>
                    <b styleName={style}>{td}</b>
                  </td>
                })
              }
            </tr>
          </tbody>
        </table>
      </div>

      <br/>
      <br/>

      <table styleName='plan-options-table'>
        <tbody>
          { /* UNMATCHED FUNDS */ }
          <tr styleName='table-disclaimer-row'>
            <th colSpan='9'>
              <div styleName='table-disclaimer'>
                <b><LinkIcon nospace faclass='fa-exclamation-triangle'/>&nbsp;Unmatched funds</b>
                <br/>
                {
                  activePlan.unmatched_funds_count
                } plan options were not matched to any
                mutual fund, with {
                  fm(activePlan.unmatched_fund_assets)
                } invested by plan participants,
                making up {
                  fp(activePlan.unmatched_fund_weight)
                } of plan assets.
                Unmatched plan options are things like
                employee stock ownership funds,
                money market funds, and stable value funds,
                but could also include separately managed accounts where
                there is little or no transparency into fund
                holdings. <b>These plan options may
                include
                arms manufacturer investments that aren't
                accounted for in the figures above.</b>
                <br/>
                <br/>
              </div>
            </th>
          </tr>
          <tr>
            <td colSpan='8'>
              <b>Plan option name</b>
            </td>
            <td>
              <b>Market value</b>
            </td>
          </tr>

          { /* UNMATCHED PLAN OPTIONS AS ROWS 1
               FOR EACH PLAN OPTION... */
            activePlan.plan_options_table.map((o, i4)=>{
              const plan_option_name = o[0]
              const fund_id = o[2]
              const market_value = o[4]
              // IF IT HAS A FUND_ID, SKIP IT
              if (!['~', 'FTSP00000G'].includes(fund_id)) {
                return null
              }
              // IF NO FUND_ID, IT'S UNMATCHED
              // RETURN A ROW WITH LESS DATA
              const _k = 'plan-option-table-'+
                'unmatched-option-'+i4
              return <tr key={_k} styleName='plan-option-table-row'>
                <td colSpan='8'>{plan_option_name}</td>
                <td>{fm(market_value)}</td>
              </tr>
            })
          }
          { /* TOTAL ROW FOR UNMATCHED FUNDS  */ }
          <tr styleName='table-total-row'>
            <td colSpan='8'>
              <b>All unmatched funds</b>
            </td>
            <td>
              <b>{fm(activePlan.unmatched_fund_assets)}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class PlanOptionsTableMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounceTime: 500,
      sort: 'plan_option_name',
      asc: true,
      planOptionsData: props.activePlan && props.activePlan.plan_options_table ? props.activePlan.plan_options_table : [],
      loading: false,
      reloadingTimeout: null,
      activeFilter: 'mil',
      activeFilterLabel: 'All military weapons',
    }
  }
  //
  clickFilter = (filterCode) => {
    if (filterCode === this.state.activeFilter) { return }
 
    const filterLabel = {
      mil: 'All military weapons',
      nw:  'Nuclear weapons',
      cm:  'Controversial weapons',
    }[filterCode]

    this.setState({
      activeFilter: filterCode,
      activeFilterLabel: filterLabel
    })

    const _filterCode = filterCode
    let newSort = this.state.sort.replace('_mil_', '_'+_filterCode+'_')
    newSort = newSort.replace('_nw_', '_'+_filterCode+'_')
    newSort = newSort.replace('_cm_', '_'+_filterCode+'_')
    const isString = (newSort === 'plan_short_name' || newSort === 'ticker')
    const sameAsc = (newSort===this.state.sort)
    this.clickPlanOptionsTableHeader(newSort, isString, sameAsc)
  }
  //
  clickPlanOptionsTableHeader = (c, isString=false, sameAsc=false) => {
    // const [0plan_option_name,
    //        1ticker,
    //        2fund_id,
    //        3investment_vehicle_id,
    //        4market_value,
    //        5ff_all_weight_equity,
    //        6ff_all_asset_equity,
    //        7ff_all_weight_bond,
    //        8ff_all_asset_bond,
    //        9ff_all_weight_both,
    //        10ff_all_asset_both,
    //        11wff_mil_weight_equity,
    //        12wff_mil_asset_equity,
    //        13wff_mil_weight_bond,
    //        14wff_mil_asset_bond,
    //        15wff_mil_weight_both,
    //        16wff_mil_asset_both,
    //        17wff_cluster_munitions_weight_equity,
    //        18wff_cluster_munitions_asset_equity,
    //        19wff_cluster_munitions_weight_bond,
    //        20wff_cluster_munitions_asset_bond,
    //        21wff_cluster_munitions_weight_both,
    //        22wff_cluster_munitions_asset_both,
    //        23wff_nuclear_weapons_weight_equity,
    //        24wff_nuclear_weapons_asset_equity,
    //        25wff_nuclear_weapons_weight_bond,
    //        26wff_nuclear_weapons_asset_bond,
    //        27wff_nuclear_weapons_weight_both,
    //        28wff_nuclear_weapons_asset_both] = o
    // ['plan_option_name', 'Plan option'],
    // ['ticker', 'Rated as'],
    // ['market_value', 'Market value'],
    // ['wff_mil_weight_equity', 'Exposure'],
    // ['wff_mil_asset_equity', 'Investments'],
    // ['wff_mil_weight_bond', 'Exposure'],
    // ['wff_mil_asset_bond', 'Investments'],
    // ['wff_mil_weight_both', 'Exposure'],
    // ['wff_mil_asset_both', 'Investments'],
    const cDict = {
      'plan_option_name' :      0,
      'ticker' :                1,
      'market_value' :          4,
      'wff_mil_weight_equity' : 11,
      'wff_mil_asset_equity' :  12,
      'wff_mil_weight_bond' :   13,
      'wff_mil_asset_bond' :    14,
      'wff_mil_weight_both' :   15,
      'wff_mil_asset_both' :    16,
      'wff_cm_weight_equity' :  17,
      'wff_cm_asset_equity' :   18,
      'wff_cm_weight_bond' :    19,
      'wff_cm_asset_bond' :     20,
      'wff_cm_weight_both' :    21,
      'wff_cm_asset_both' :     22,
      'wff_nw_weight_equity' :  23,
      'wff_nw_asset_equity' :   24,
      'wff_nw_weight_bond' :    25,
      'wff_nw_asset_bond' :     26,
      'wff_nw_weight_both' :    27,
      'wff_nw_asset_both' :     28,
    }
    let cI = null
    try {
      cI = cDict[c]
    } catch (error) {
      console.error(error);
      cI = 0
    }
    //
    if (this.state.loading) { return }
    //
    const arr = this.state.planOptionsData
    //
    // track if sort is ascending/descending
    let currAsc = this.state.asc
    if (c===this.state.sort && !sameAsc) {
      currAsc = !currAsc
    }
    //
    // sort strings
    if (isString) {
      arr.sort((a, b) => {
        // reverse sort if ascending/descending
        if (currAsc) {
          return a[cI].localeCompare(b[cI])
        } else {
          return b[cI].localeCompare(a[cI])
        }
      })
    } else {
      //
      // sort numbers
      arr.sort((a, b) => {
        // cast to number for unmatched funds
        let _a = a[cI]
        let _b = b[cI]
        if (['~', null].includes(a[cI])) {
          _a = 0
        }
        if (['~', null].includes(b[cI])) {
          _b = 0
        }
        // reverse sort if ascending/descending
        if (currAsc) {
          return parseFloat(_a) > parseFloat(_b)
        } else {
          return parseFloat(_a) < parseFloat(_b)
        }
      })
    }
    //
    // clear loading timeout
    if (this.reloadingTimeout) {
      clearTimeout(this.reloadingTimeout)
    }
    //
    // set sort and ascending state, and loading
    // create timeout to end loading and set sorted results
    // for (let i = 0; i < arr.length; i++) {
    //   console.log(arr[i][0], arr[i][cI])
    // } 

    // scroller.scrollTo('scroll-to-plan-options')

    this.setState({
      asc: currAsc,
      sort: c,
      loading: true,
      reloadingTimeout: setTimeout(
        () => {
          this.setState({
            loading: false,
            planOptionsData: arr,
          })
        },
        this.state.debounceTime
      )
    })
  }

  //
  opener(rowLabel) {
    const newState = {}
    newState[rowLabel] = !this.state[rowLabel]
    this.setState(newState)
  }
  //
  render() {
    if (!this.props.activePlan) { return null }
    //
    const { activePlan } = this.props
    //
    return <div styleName='plan-options-table-responsive-wrap'>
      <div>
        <div styleName='sticky-table-header'>
          <FilterButtons activeFilter={this.state.activeFilter} clickFilter={this.clickFilter} />
        </div>
        <div id='scroll-to-plan-options'/>
        { /* Plan option >> Arms manufacturer bond exposure */ }
        <div styleName='plan-options-table-responsive-row responsive-header-row'>
          <div>
           Plan option
          </div>
          <div>
           Investments: <span styleName='nowrap'>{this.state.activeFilterLabel}</span>
          </div>
          <div/>
        </div>
        { /* All Matched Funds >> Bond Exposure % >> More... */ }
        <div
          styleName='plan-options-table-responsive-button-row responsive-total-row'
          onClick={ () => { this.opener('all-matched-funds') } }
        >
          <div>
            All matched funds
          </div>
          <div styleName='responsive-figure'>
            { fm(activePlan['wff_'+this.state.activeFilter+'_asset_both']) }
          </div>
          <div>
            <LinkIcon nospace faclass='fa-ellipsis-v'/>
          </div>
        </div>
        <SlideDown>
          {
            this.state['all-matched-funds'] ?
              <div styleName='plan-options-table-responsive-more-results-row' >
                {
                  [
                    ['Market value', fm(activePlan.matched_fund_assets), 1, 0],
                    ['Stocks - ' + this.state.activeFilterLabel, null, 0, 1],
                    ['Exposure', fp(activePlan['wff_'+this.state.activeFilter+'_weight_equity']), 1, 0],
                    ['Investments', fm(activePlan['wff_'+this.state.activeFilter+'_asset_equity']), 1, 0],
                    ['Bonds - ' + this.state.activeFilterLabel, null, 0, 1],
                    ['Exposure', fp(activePlan['wff_'+this.state.activeFilter+'_weight_bond']), 1, 0],
                    ['Investments', fm(activePlan['wff_'+this.state.activeFilter+'_asset_bond']), 1, 0],
                    ['TOTAL - ' + this.state.activeFilterLabel, null, 0, 1],
                    ['Exposure', fp(activePlan['wff_'+this.state.activeFilter+'_weight_both']), 1, 0],
                    ['Investments', fm(activePlan['wff_'+this.state.activeFilter+'_asset_both']), 1, 0],
                  ].map((oLblVal, i7) => {
                    const [lbl, val, isFigure, isBufferRow] = oLblVal
                    return (
                      <div
                        styleName='responsive-more-results-data-row'
                        key={'all-matched-funds-responsive-more-results-data-row-'+i7}
                      >
                        <div styleName={isBufferRow ? 'responsive-buffer-row' : ''}>
                          {lbl}
                        </div>
                        <div styleName={isFigure ? 'responsive-figure' : ''}>
                          {val}
                        </div>
                      </div>
                    )
                  })
                }
              </div> :
              null
          }
        </SlideDown>
        { /* Plan option name >> Bond Exposure % >> More... */ }
        { /* MATCHED PLAN OPTIONS AS ROWS */
          /* FOR EACH PLAN OPTION... */
          this.state.planOptionsData.map((o, i5)=>{
            const [plan_option_name,
                   ticker,
                   fund_id,
                   investment_vehicle_id,
                   market_value,
                   ff_all_weight_equity,
                   ff_all_asset_equity,
                   ff_all_weight_bond,
                   ff_all_asset_bond,
                   ff_all_weight_both,
                   ff_all_asset_both,
                   wff_mil_weight_equity,
                   wff_mil_asset_equity,
                   wff_mil_weight_bond,
                   wff_mil_asset_bond,
                   wff_mil_weight_both,
                   wff_mil_asset_both,
                   wff_cm_weight_equity,
                   wff_cm_asset_equity,
                   wff_cm_weight_bond,
                   wff_cm_asset_bond,
                   wff_cm_weight_both,
                   wff_cm_asset_both,
                   wff_nw_weight_equity,
                   wff_nw_asset_equity,
                   wff_nw_weight_bond,
                   wff_nw_asset_bond,
                   wff_nw_weight_both,
                   wff_nw_asset_both] = o

            const rowObj = {
              wff_mil_weight_equity,
              wff_mil_asset_equity,
              wff_mil_weight_bond,
              wff_mil_asset_bond,
              wff_mil_weight_both,
              wff_mil_asset_both,
              wff_cm_weight_equity,
              wff_cm_asset_equity,
              wff_cm_weight_bond,
              wff_cm_asset_bond,
              wff_cm_weight_both,
              wff_cm_asset_both,
              wff_nw_weight_equity,
              wff_nw_asset_equity,
              wff_nw_weight_bond,
              wff_nw_asset_bond,
              wff_nw_weight_both,
              wff_nw_asset_both
            }

            // IF IT HAS NO FUND_ID, SKIP IT
            if (['~', 'FTSP00000G'].includes(fund_id)) { return null }
            // IF FUND_ID, IT'S MATCHED
            // RETURN A ROW WITH MORE DATA
            const k = 'responsive-table-option-matched-'+i5
            return (
              <div key={k}>
                <div
                  styleName='plan-options-table-responsive-button-row'
                  onClick={ () => { this.opener('matched-'+i5) } }
                >
                  <div>
                    <b>{plan_option_name}</b>
                  </div>
                  <div styleName='responsive-figure'>
                    <b styleName='red strong'>{ fm(rowObj['wff_'+this.state.activeFilter+'_asset_both']   ) }</b>
                  </div>
                  <div>
                    <LinkIcon nospace faclass='fa-ellipsis-v'/>
                  </div>
                </div>
                <SlideDown>
                  {
                    this.state['matched-'+i5] ?
                      <div styleName='plan-options-table-responsive-more-results-row' >
                        {
                          [
                            ['Rated as', ticker, 0, 0],
                            ['Market value', fm(market_value), 1, 0],
                            ['Stocks - ' + this.state.activeFilterLabel, null, 0, 1],
                            ['Exposure', fp(rowObj['wff_'+this.state.activeFilter+'_weight_equity']), 1, 0],
                            ['Investments', fm(rowObj['wff_'+this.state.activeFilter+'_asset_equity']), 1, 0],
                            ['Bonds - ' + this.state.activeFilterLabel, null, 0, 1],
                            ['Exposure', fp(rowObj['wff_'+this.state.activeFilter+'_weight_bond']), 1, 0],
                            ['Investments', fm(rowObj['wff_'+this.state.activeFilter+'_asset_bond']), 1, 0],
                            ['TOTAL - ' + this.state.activeFilterLabel, null, 0, 1],
                            ['Exposure', fp(rowObj['wff_'+this.state.activeFilter+'_weight_both']), 1, 0],
                            ['Investments', fm(rowObj['wff_'+this.state.activeFilter+'_asset_both']), 1, 0],
                          ].map((oLblVal, i6) => {
                            const [lbl, val, isFigure, isBufferRow] = oLblVal
                            return (
                              <div
                                styleName='responsive-more-results-data-row'
                                key={'plan-option-responsive-more-results-data-row-'+i6}
                              >
                                <div styleName={isBufferRow ? 'responsive-buffer-row' : ''}>
                                  {lbl}
                                </div>
                                <div styleName={isFigure ? 'responsive-figure' : ''}>
                                  {val}
                                </div>
                              </div>
                            )
                          })
                        }
                      </div> :
                      null
                  }
                </SlideDown>
              </div>
            )
          })
        }
      </div>

      <div styleName='plan-options-table-responsive-row responsive-header-row'>
        <div>
          <div styleName='table-disclaimer'>
            <b><LinkIcon nospace faclass='fa-exclamation-triangle'/>&nbsp;
            Unmatched funds</b>
            <br/>
            {
              activePlan.unmatched_funds_count
            } plan options were not matched to any
            mutual fund, with {
              fm(activePlan.unmatched_fund_assets)
            } invested by plan participants,
            making up {
              fp(activePlan.unmatched_fund_weight)
            } of plan assets. These plan options may
            include
            arms manufacturer investments that aren't
            accounted for in the figures above.
          </div>
        </div>
      </div>
      { /* Plan option >> Arms manufacturer bond exposure */ }
      <div styleName='plan-options-table-responsive-row responsive-header-row'>
        <div>
         Plan option
        </div>
        <div>
         Market value
        </div>
        <div/>
      </div>
      { /* UNMATCHED PLAN OPTIONS AS ROWS 2 */
        /* FOR EACH PLAN OPTION... */
        activePlan.plan_options_table.map((o, i5)=>{
          const [plan_option_name,
                 ticker,
                 fund_id,
                 investment_vehicle_id,
                 market_value] = o
          // IF IT HAS NO FUND_ID, SKIP IT
          if (!['~', 'FTSP00000G'].includes(fund_id)) { return null }
          // IF FUND_ID, IT'S MATCHED
          // RETURN A ROW WITH MORE DATA
          const k = 'responsive-table-option-matched-'+i5
          return (
            <div key={k}>
              <div
                styleName='plan-options-table-responsive-button-row'
                onClick={ () => { this.opener('matched-'+i5) } }
              >
                <div>
                  {plan_option_name}
                </div>
                <div styleName='responsive-figure'>
                  { fm(market_value) }
                </div >
                <div />
              </div>
            </div>
          )
        })
      }
      { /* All Unatched Funds >>  */ }
      <div
        styleName='plan-options-table-responsive-button-row responsive-total-row'
      >
        <div>
          All unmatched funds
        </div>
        <div styleName='responsive-figure'>
          { fm(activePlan.unmatched_fund_assets) }
        </div>
        <div/>
      </div>
    </div>
  }
}


//
// <ToolkitBanner> component
// Display: panel with link to action toolkit
//
@CSSModules(Styles, {allowMultiple:true})
class ToolkitBanner extends Component {
  render() {
    const iconDove = require( '../../../static/images/toolkit/dove.png' )
    //
    return <div styleName='toolkit-banner-wrap'>
      <ContainerDivs>
        <Link
          to={config.routes.toolkit}
          title='Use our weapon free action toolkit'
        >
          <div styleName='toolkit-header'>
            <div styleName='toolkit-header-inner'>
              <div styleName='toolkit-header-label-wrap'>
                <div styleName='toolkit-header-label'>
                  Weapon free action toolkit
                </div>
              </div>
              <h1 styleName='toolkit-title'>
                Make a change and invest in a peaceful future.
              </h1>
            </div>
            <img
              src={iconDove}
              role='presentation'
              styleName='toolkit-header-icon'
            />
          </div>
        </Link>
      </ContainerDivs>
    </div>
  }
}


//
// <TargetDateSelect> component
// Includes: <Select> and onTdSelect()
//             to select an active TD series,
//           <TargetDateResults> to display results
//             for active TD series
//
@CSSModules(Styles, {allowMultiple:true})
class TargetDateSelect extends Component {
  constructor(props) {
    super(props)
    const defaultTdSelectOption = {
      name: '2025 fund for all series',
      label: '2025 fund for all series'
    }
    const tdSelectOptions = [defaultTdSelectOption]
    Object.keys(config.targetDateBondsSource).map((key, i) => {
      tdSelectOptions.push({name: key, label: key})
      return null
    })
    this.state = {
      tdSelected: defaultTdSelectOption,
      tdLoading: false,
      tdTimeout: null,
      tdSelectOptions: tdSelectOptions,
      defaultTdSelectOption
    }
  }

  onTdSelect = (val) => {
    // similar logic as onPlanSelect
    // except there is a default (all 2025 funds)
    // so there is a setTimeout to go back to default
    // even if there is no val selected
    if (this.state.tdTimeout) {
      clearTimeout(this.state.tdTimeout)
    }
    if (val) {
      this.setState({
        tdSelected: val,
        tdLoading: true,
        tdTimeout: setTimeout(()=>{
          this.setState({
            tdLoading: false,
          })
        }, 500)
      })
    } else {
      this.setState({
        tdSelected: this.state.defaultTdSelectOption,
        tdLoading: true,
        tdTimeout: setTimeout(()=>{
          this.setState({
            tdLoading: false,
          })
        }, 500)
      })
    }
  }

  render() {
    const iconTargetDates = require( '../../../static/images/icon-target-dates.png' )
    // select active TD
    let activeTdKey = null
    if (this.state.tdSelected.name !== '2025 fund for all series') {
      activeTdKey = this.state.tdSelected.name
    }
    //
    return (
      <div id='target-dates' styleName='target-date-select-wrap'>
        <ContainerDivs>
          <div styleName='plan-select-flex'>
            <div>
              <h2>Target date fund series</h2>
              <p>
                Many 401(k)s are based around target date fund series as
                the default investment option.
                Select a target date series to see how much it
                has invested in arms manufacturer bonds and stocks across the different
                dates.
              </p>

              <h3 styleName='select-dropdown-plan-label'>
                Search target date series
              </h3>
              <div styleName='select-dropdown-plan-wrap'>
                <Select
                  name='td-select'
                  value={this.state.tdSelected}
                  options={this.state.tdSelectOptions}
                  onChange={this.onTdSelect}
                />
              </div>
            </div>
            { /* <img
              styleName='plan-select-img'
              src={iconTargetDates}
              alt='Target date funds'
            /> */ }
          </div>
          <TargetDateResults tdLoading={this.state.tdLoading} activeTdKey={activeTdKey} />
          <div styleName='target-date-results-disclaimer'>
            * To see the figures for these charts,
            download the dataset
            in the <ScrollLink
              activeClass='active-scroll-link'
              to='methodology'
              spy
              smooth
              offset={-70}
              duration={500}
            >
              <span styleName='red-link'>
                methodology section
              </span>
            </ScrollLink>.
          </div>
          { /* <ScrollToTop color='dkpink'/> */ }
        </ContainerDivs>
      </div>
    )
  }
}


//
// <TargetDateResults> component
// Display: chart image for all TD series, 2025 fund,
//          chart images for specific TD series,
//            if there is an active TD series
// @param activeTdKey: Key for the active TD series
// @param tdLoading: T/F to show loading spinner. Controlled by timeout
//                   in <TargetDateSelect> onTdSelect()
//
@CSSModules(Styles, {allowMultiple:true})
class TargetDateResults extends Component {
  static propTypes = {
    activeTdKey: PropTypes.string,
    tdLoading: PropTypes.bool
  }
  render() {
    const urlPrefix = 'https://iyv-charts.s3-us-west-2.amazonaws.com/military_weapon_bonds/'
    const allTdsWeightChartUrl = `${urlPrefix}2025 Fund of Target Date Series military weapon bonds weight ${currYYYYMM}.png`
    const allTdsWeightChartAlt = '2025 fund of target date series weight chart'
    //
    let tdWeightChartUrl = null
    let tdWeightChartAlt = null
    if (this.props.activeTdKey) {
      tdWeightChartUrl = `${urlPrefix}${this.props.activeTdKey} military weapon bonds weight ${currYYYYMM}.png`
      tdWeightChartAlt = `${this.props.activeTdKey} weight chart`
    }
    //
    return (
      <div>
        { /* LOADING ICON DURING PLAN SELECT TIMEOUT */
          this.props.tdLoading ?
            (
              <div styleName='td-loader-wrap'>
                <Loader
                  options={{ scale: 0.70, position: 'relative' }}
                  loaded={false}
                />
              </div>
            ) :
            null
        }

        { /* CHART IMAGE FOR ALL TARGET DATE SERIES */
          !this.props.tdLoading && !this.props.activeTdKey ?
            (
              <div styleName='td-chart-col'>
                <div styleName='plan-summary-col'>
                  <h3 styleName='plan-summary-section-heading'>
                    2025 FUNDS OF POPULAR TARGET DATE SERIES
                  </h3>
                </div>
                <p styleName='chart-disclaimer'>
                  <LinkIcon nospace faclass='fa-info-circle'/>
                  &nbsp;This chart compares 10 popular target date series
                  using the 2025 fund. Those towards the
                  top of the chart have more arms manufacturer exposure
                  in the 2025 fund, and those towards the
                  bottom have less exposure. The 2025 fund
                  is used for the comparison
                  as it is more bond-heavy, being marketed to people
                  who are nearing
                  retirement.
                </p>
                <div styleName='chart-img-wrap'>
                  <Link
                    to={allTdsWeightChartUrl}
                    title={'2025 series weight chart'}
                    targetBlank
                  >
                    <img
                      src={allTdsWeightChartUrl}
                      alt={allTdsWeightChartAlt}
                      styleName='chart-img'
                    />
                    <span styleName='chart-expand-label visible-xs'>
                      Click to enlarge<LinkIcon faclass='fa-expand'/>
                    </span>
                  </Link>
                </div>
              </div>
            ) :
            null
        }

        { /* CHART IMAGE TD SERIES - BY WEIGHT */
          !this.props.tdLoading && this.props.activeTdKey ?
            (
              <div styleName='td-chart-col'>
                <div styleName='plan-summary-col'>
                  <h3 styleName='plan-summary-section-heading'>
                    SERIES NAME
                  </h3>
                  <p>
                    {this.props.activeTdKey}
                  </p>
                </div>
                <p styleName='chart-disclaimer'>
                  <LinkIcon nospace faclass='fa-info-circle'/>
                  &nbsp;This chart shows the percent of each
                  fund in the target date series
                  that is invested in arms manufacturer bonds
                  and stocks. The funds at the
                  top of the chart are
                  marketed at people further from retirement,
                  and are the most stock-heavy,
                  and the funds at the bottom of the chart
                  are marketed at people closer to retirement,
                  and are more bond-heavy.
                </p>
                <div styleName='chart-img-wrap'>
                  <Link
                    to={tdWeightChartUrl}
                    title={tdWeightChartAlt}
                    targetBlank
                  >
                    <img
                      src={tdWeightChartUrl}
                      alt={tdWeightChartAlt}
                      styleName='chart-img-td'
                    />
                    <span styleName='chart-expand-label visible-xs'>
                      Click to enlarge<LinkIcon faclass='fa-expand'/>
                    </span>
                  </Link>
                </div>
              </div>
            ) :
            null
        }
      </div>
    )
  }
}


//
// <Contacts> component
// Display: link to contact form
// Includes: <SignupForm> component
//
@CSSModules(Styles, {allowMultiple:true})
class Contacts extends Component {
  render() {
    return (
      <div>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6}>
            <div styleName='contact-col-left'>
              <h3>
                Questions?
              </h3>
              <p>
                If you have questions about your company's retirement plan,
                get in touch.
              </p>
              <Link to={config.links.contact} title='Contact As You Sow' redbutton>
                <h3 styleName='solutions-contact-link'>
                  Contact us<LinkIcon />
                </h3>
              </Link>
            </div>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6}>
            <div styleName='contact-col-right '>
              <h3>
                Sign up for updates
              </h3>
              <p>
                We'll let you know when we add new companies, new funds, and
                new features.
              </p>
              <div styleName='solutions-col-signup'>
                { /* TODO clean up this SignupForm component
                  <SignupForm url='344561_46053pi_344561_46053' id='344561_46053pi_344561_46053'/>
                */ }
              </div>
            </div>
        </Col>
        </Row>
        <br/>
        <br/>
        <ScrollToTop color='white'/>
      </div>
    )
  }
}


@CSSModules(Styles, { allowMultiple: true })
class RpFAQs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: {},
      faqs: [
        [
          <span>
            How do you identify arms manufacturer companies?
          </span>,
          <span>
            Our analysis checks funds for investments in arms manufacturers and military contractors. This list includes two sub-categories: manufacturers and servicers of nuclear weapons; and current and recent manufacturers of controversial weapons, such as cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium. To build these lists, we used data from over 20 sources, including investment firms and pension funds with ethical investment guidelines; data from industry news outlets; and research from non-profit advocacy groups. Learn more on our <Link to={config.routes.howitworks} title='Methodology'>methodology page</Link>.
          </span>,
        ],
        [
          <span>
            How do you track arms manufacturer investments?
          </span>,
          <span>
            Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. We calculate the total number of flagged holdings in the fund, and the total amount and percentage of the fund’s assets that are invested in those companies. We then cross-reference these figures with data on retirement plan investments to derive total investment amounts and exposure percentages for each retirement plan. Learn more on our <Link to={config.routes.howitworks} title='Methodology'>methodology page</Link>.
          </span>,
        ],
        [
          <span>
            What are the impacts of investing in arms manufacturer corporate bonds?
          </span>,
          <span>
            Buying bonds (also called debt or fixed income) means you’re lending money to some company or organization. Companies issue bonds to pay for expansions to operations. This means that investments in corporate bonds issued by military weapon manufacturers could be financing expansion of production of weapons.
          </span>,
        ],
        [
          <span>
            What can employees do to align their investments with their values?
          </span>,
          <span>
            Our <Link to={config.routes.toolkit} title='Weapon Free Action Toolkit'>weapon free action toolkit</Link> can help you make a change and invest in a peaceful future. The toolkit includes sample language you can send to your 401(k) administrator, asking for sustinable investment options in your plan.
          </span>,
        ],
      ]
    }
  }

  render() {
    return <div styleName='rp-faq-wrap'>
      <ContainerDivs>
        <Row>
          <Col xs={12} sm={12} md={5} lg={5}>
            <h2>
              Frequently<br/>asked<br/>questions
            </h2>
          </Col>
          <Col xs={12} sm={12} md={7} lg={7}>
            <br/>
            {
              this.state.faqs.map((e, i) => {
                return <div styleName='rp-faq-item' key={'rp-faq-item'+i}>
                  <div
                    onClick={()=>{
                      const newOpenState = this.state.open
                      newOpenState[i] = (!newOpenState[i] || newOpenState[i] === null)
                      this.setState({ open: newOpenState })
                    }}
                    styleName='rp-faq-q'
                  >
                    <h3>{e[0]}</h3>
                    <LinkIcon nospace faclass={this.state.open[i] ?
                                                 'fa-angle-up' :
                                                 'fa-angle-down'} />
                  </div>
                  <SlideDown>
                    {
                      this.state.open[i] ?
                        <div styleName='rp-faq-a'>
                          <p>{e[1]}</p>
                        </div> :
                        null
                    }
                  </SlideDown>
                </div>
              })
            }
          </Col>
        </Row>
      </ContainerDivs>
    </div>
  }
}


//
// <Methodology> component
// Display text of methodology
// Display link to spreadsheet of bulk results
//
@CSSModules(Styles, {allowMultiple:true})
class Methodology extends Component {
  constructor(props) {
    super(props)
    this.state = {
      methodologyOpen: false,
      industryListOpen: false
    }
  }

  render() {
    return (
      <div id='methodology' styleName='methodology'>
        <ContainerDivs>
          <h2>Methodology</h2>
          <br/>
          <h3 styleName='methodology-spreadsheet-download'>
            <Link
              to='https://iyv-charts.s3.us-west-2.amazonaws.com/files/Weapon+Free+Funds+-+As+You+Sow+-+Retirement+Plans+-+dataset+2024.xlsx'
              title='Weapon Free Funds - As You Sow - Retirement Plans - dataset 2024.xlsx'
            >
              Download dataset
              <LinkIcon faclass='fa-file-excel-o'/>
              <LinkIcon faclass='fa-download'/>
            </Link>
          </h3>
          <br/>
          <p>
            The results above are based on an analysis of the holdings of mutual funds found in retirement plans of major companies, as well as popular target date funds series used as the default investment option in hundreds of other retirement plans.
          </p>

          <button
            styleName='section-slidedown-button'
            onClick={ () => {
              this.setState({
                methodologyOpen: !this.state.methodologyOpen
              })
            }}
          >
            <h2 styleName='section-slidedown-label'>
              See the full methodology
            </h2>
            <div styleName='section-slidedown-icon'>
              <LinkIcon faclass={ this.state.methodologyOpen ? 'fa-angle-up' : 'fa-angle-down' } />
            </div>
          </button>

          <SlideDown>
            {
              this.state.methodologyOpen ?
                (
                  <div>
                    <h3>
                      AS-OF DATE
                    </h3>
                    <p>
                      This analysis was released in June 2024, using the most recent fund data and retirement plan data available. Fund portfolios are reported monthly or quarterly; retirement plan data is reported annually. For most retirement plans, the data was released in 2023, representing plan options and assets as of 31 December 2022. For most fund portfolios, the data was released at the end of May 2024, or in the few months prior.
                    </p>
                    <h3>
                      RETIREMENT PLANS
                    </h3>
                    <p>
                      The data on retirement plan options is the same used in the equity analysis in the main Retirement Plan Sustainability Scorecard. For more information on how this data is collected from Form 5500 filings on the Department of Labor website, and matched to mutual fund data, see our <Link to={config.routes.methodology} title='Methodology'><span styleName='red-link'>main methodology page</span></Link>.
                    </p>
                    <h3>
                      MILITARY WEAPON STOCKS
                    </h3>
                    <p>
                      The data on military weapon stock holdings in retirement plan options is the same used in the fund scorecards in the Weapon Free Funds databse. For more information on how we track military weapon stocks in funds, see our <Link to={config.routes.methodology} title='Methodology'><span styleName='red-link'>main methodology page</span></Link>.
                    </p>
                    <h3>
                      MILITARY WEAPON CORPORATE BONDS
                    </h3>
                    <p>
                      For the purposes of this analysis, as “corporate bonds” we considered different kinds of debt issued by a company in order for it to raise capital. This includes traditional corporate bonds, convertible bonds, corporate inflation-protected bonds, commercial paper, capital-contingent bonds, contingent convertible bonds, and some preferred stock (which are often treated like bonds by investors). Because some military weapon companies and projects are state-owned, we also included government agency debt, excluding mortgage issuers like Fannie Mae.
                    </p>
                    <p>
                      Bonds that are not part of this analysis include government bonds (e.g. treasury and muni bonds), mortgage bonds, asset-backed bonds like Collateral Loan Obligations, and more complex securities like derivatives, futures, options, warrants, structured products, and swaps.
                    </p>
                    <h3>
                      TRACKING MILITARY WEAPON HOLDINGS
                    </h3>
                    <p>
                      The fund holdings of the retirement plan options are filtered down to stocks and bonds issued by arms manufacturer and military contractor companies. This list include all companies on our <Link to={config.routes.howitworks+'#companies'} title='Publicly-traded companies: Military weapons'><span styleName='red-link'>publicly-traded military weapon company list</span></Link>, as well as non-publicly-traded companies with arms manufacturing or military contracting operations.
                    </p>
                    <h3>
                      CALCULATING EXPOSURE AND CONCENTRATION
                    </h3>
                    <p>
                      Once retirement plan options are matched to appropriate mutual funds, and military weapon holdings identified, exposure is calculated for each mutual fund (defined as the percent of fund assets invested in holdings classified as military weapon stocks and corporate bonds).
                    </p>
                    <p styleName='methodology-callout-p'>
                      <b>Long holdings only:</b> All exposure and concentration statistics in this analysis are based on long-position holdings only. Short positions and liabilities are ignored.
                    </p>
                    <p>
                      Once each mutual fund has the exposure calculated, the figures are applied to the retirement plan options. Each retirement plan option has some amount of assets ($USD) invested in it by plan participants. Using the fund-level exposures, we calculate summary statistics for each retirement plan:
                    </p>
                    <ul>
                      <li>
                        <b>Investments:</b> The amount of assets ($USD) invested by plan participants in military weapon stocks or corporate bonds across all plan options
                      </li>
                      <li>
                        <b>Exposure:</b> The percent of all plan assets classified as military weapon stocks or corporate bonds
                      </li>
                      <li>
                        <b>Concentration:</b> The percent of assets classified as military weapon within stocks holdings or corporate bond holdings
                      </li>
                    </ul>
                    <h3>
                      TOP MILITARY WEAPON HOLDINGS
                    </h3>
                    <p>
                      For each retirement plan, we identify the top 10 companies found within military weapon stocks or corporate bonds across all plan options.
                    </p>
                    <p>
                      Using the settings, you can filter to show figures and tables for two subsets of military weapon companies: companies connected with the production and/or maintenance of <b>nuclear weapons</b>; and companies connected with the production and/or maintenance of <b>controversial weapons</b>, including cluster munitions, incendiary weapons, anti-personnel landmines, and depleted uranium.
                    </p>
                    <h3>
                      PLAN OPTION CHARTS
                    </h3>
                    <p>
                      For each retirement plan, we show two bar charts:
                    </p>
                    <ul>
                      <li>
                        <b>Percent:</b> Showing the exposure percent of each plan option to military weapon stocks and corporate bonds
                      </li>
                      <li>
                        <b>$USD:</b> Showing the total assets invested by plan participants in military weapon stocks and corporate bonds in each plan option
                      </li>
                    </ul>
                    <h3>
                      TARGET DATE SERIES
                    </h3>
                    <p>
                      We compare the military weapon stock and bond exposure of 10 popular target date series using the 2025 fund from each series. The 2025 fund is used for the comparison as it is more bond-heavy, being marketed to people who are nearing retirement. Those fund series towards the top of the chart have more military weapon manufacturer exposure in the 2025 fund, and those towards the bottom have less exposure.
                    </p>
                    <p>
                      For each target date series, we show a chart comparing the military weapon manufacturer stock and bond exposure of the various funds within the series across target dates (2025, 2030, 2035, etc.). Most fund series have more military weapon manufacturer corporate bond exposure as the target dates near the current date, and more military weapon manufacturer stock exposure for target dates further out.
                    </p>
                    { /* <ScrollToTop color='dkpink'/> */ }
                  </div>
                ) :
                null
            }
          </SlideDown>
        </ContainerDivs>
      </div>
    )
  }
}


//
// <FossilFuelBondsIn401ks> component
// Main page layout
//
@CSSModules(Styles, {allowMultiple:true})
export default class WeaponBondsIn401ks extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      title: 'Explosive 401(k)s',
      description: 'The savings of American workers are financing arms manufacturers making nuclear missiles, cluster bombs, and other controversial military weapons.',
      url: config.domain + config.routes.weaponBondsIn401ks,
      retirementPlanIndex: ((props.params && props.params.retirementPlanIndex && props.params.retirementPlanIndex !== null) ?
        props.params.retirementPlanIndex :
        null)
    }
  }
  //
  componentWillReceiveProps(props){
    // set to empty
    if (props.params.retirementPlanIndex && props.params.retirementPlanIndex !== this.state.retirementPlanIndex) {
      this.setState({
        retirementPlanIndex: props.params.retirementPlanIndex
      })
    } else if (!props.params.retirementPlanIndex) {
      this.setState({
        retirementPlanIndex: null
      })
    }
  }
  //
  render() {
    const socialShareUrl =  config.domain+imageSocialShare.replace(/.*dist/,'/dist')
    //
    return (
      <div styleName='page' id='top'>
        { container.helmet(this.state.title,
                           this.state.description,
                           this.state.url) }
        <Helmet meta={[
          {property: 'og:image', content: socialShareUrl},
          {property: 'twitter:image', content: socialShareUrl},
        ]}/>

        <LedeNav title={this.state.title} description={this.state.description}/>

        <TheIssue />

        <PlanSelect retirementPlanIndex={this.state.retirementPlanIndex}/>

        <ToolkitBanner />

        <TargetDateSelect />

        <RpFAQs />

        <Methodology />

      </div>
    )
  }
}
